import { FC } from 'react';
import { CheckboxProps, Checkbox } from './Checkbox';
import { cn } from '@fe-learner-common';
interface LabeledCheckboxProps extends CheckboxProps {
  label: string;
}

export const LabeledCheckbox: FC<LabeledCheckboxProps> = ({
  className,
  checked,
  label,
  id,
  onChange,
  size,
}) => {
  const handleOnChange = () => {
    onChange();
  };

  return (
    <label
      className={cn(
        'lf:flex lf:h-12 lf:cursor-pointer lf:select-none lf:items-center lf:gap-3.5 lf:rounded-lg lf:px-3 lf:py-3.5 lf:hover:bg-neutral-100',
        className,
      )}
      onClick={(event) => {
        event.preventDefault();

        handleOnChange();
      }}
      htmlFor={id}
    >
      <Checkbox size={size} checked={checked} id={id} onChange={onChange} />
      <span
        className={cn('lf:cursor-pointer lf:text-title-sm lf:first-letter:capitalize', {
          'lf:text-neutral-500': !checked,
        })}
      >
        {label}
      </span>
    </label>
  );
};
